import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_TEST_ORDERS } from "../../config/connString";
import decodedUserDetails from "utils/decodedUserDetails";

const createTestOrder = createAsyncThunk(
  "test-orders/create-test-order",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();
      const response = await api.post(URL_TEST_ORDERS, {
        clientWillDrawSpecimen: data.clientWillDrawSpecimen,
        patientId: data.patientId,
        clientId: clientId,
        providerId: data.providerId,
        diagnosesList: data.diagnosesList,
        specialHandlings: data.specialHandlings,
        testOrderDetails: data.testOrderDetails,
        patientSpecimens: data.patientSpecimens,
        orderedBy: data.orderedBy || null,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createTestOrder };
